import { render, staticRenderFns } from "./SfContentPages.vue?vue&type=template&id=298d932a"
import script from "./SfContentPages.vue?vue&type=script&lang=js"
export * from "./SfContentPages.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfContentPages.vue?vue&type=style&index=0&id=298d932a&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "411f51b4"
  
)

export default component.exports